import React, {useState} from 'react'
import ReactDOM from 'react-dom'
import ReactModal from 'react-modal';
import EnquiryForm from 'components/product/grid2/enquiry-form'

ReactModal.setAppElement('body');


const SectionForm = ({config}) => {

	const [ selectedSection, setSelectedSection ] = useState( false );


	return (
		<>
			<div className="grid-x grid-padding-x second">
			{config.sections.map((section, index) => (
				<div className="cell small-6 medium-4 large-2" key={`section-${section.id}`}>
					<a onClick={() => setSelectedSection( section )}>
						<div className={`header-image ${section.sectionClass}`}>
							{section.trending && <span className="banner-tag red">Trending</span>}
						</div>
						<div className="align-content vertical center">
							<span className="header-image--cat">{section.name}</span>
							<span className="icon icon-right small right"></span>
						</div>
					</a>
				</div>
			))}
			</div>
			{/* A sized card on web, a bottom sheet on mobile — both from the same
			    markup, styled by .section-modal (design handoff 6a/6b). */}
			<ReactModal
				isOpen={selectedSection ? true : false}
				onRequestClose={() => setSelectedSection( false )}
				contentLabel={selectedSection ? `Search for ${selectedSection.name}` : 'Search'}
				className="section-modal"
				overlayClassName="section-modal__overlay"
			>
				{selectedSection ? (
				<>
					<div className="section-modal__handle" aria-hidden="true"></div>
					<div className="section-modal__head">
						<div className={`section-modal__thumb ${selectedSection.sectionClass}`}></div>
						<div className="section-modal__titles">
							<h2>{selectedSection.name}</h2>
							<p>Tell us a little about the group and we'll find the good stuff</p>
						</div>
						<button onClick={() => setSelectedSection( false )} className="section-modal__close" aria-label="Close">
							<span aria-hidden="true">✕</span>
						</button>
					</div>
					<EnquiryForm
						config={{
							locations: selectedSection.locations,
							hasRegion: selectedSection.hasRegion,
							path: '/' + selectedSection.slug + '/*',
							defaultValues: config.defaultValues,
							autoSubmit: false,
							token: config.token
						}}
						type="card"
						hideLocation={false}
						labels={true}
						cityChips={true}
						vibes={true}
						ctaLabel={`Search ${selectedSection.name.toLowerCase()}`}
						modal={true}
						askPlaceholder={'e.g. "12 of us in Brighton, cocktails and something crafty"'}
					/>
				</>
				):null}
			</ReactModal>
		</>
	)
}

document.addEventListener('DOMContentLoaded', () => {

	const form = document.querySelector('#section-form');
	const config = JSON.parse( form.getAttribute('config') );

	ReactDOM.render(
		<SectionForm
            config={config}
            type="white"
        />,
		form,
	)
});
